import React from "react";
import ReactDOM from "react-dom";
import "./css/index.css";
import App from "./components/main/App";

ReactDOM.render(<App />, document.getElementById("root"));
